export enum SoftwareTaskStatus {
    NotStarted = "Not Started",
    InProgress = "In Progress",
    Complete = "Complete"
}